var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "imc_memorandum_inside row" },
    [
      _vm.is_show
        ? _c("mem_preview_left", { key: "menu_preview_left" })
        : _vm._e(),
      _vm._v(" "),
      _vm.is_show
        ? _c("mem_preview_right", { key: "menu_preview_right" })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }